import {Component, ElementRef, inject, model, OnInit, ViewChild} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TranslateService } from '@ngx-translate/core';
import * as uuid from 'uuid';
import { LabelOptions } from '@core/classes/options/label-options';

export class SwitchOptions {
  id?: string = uuid.v4();
  label?: LabelOptions;
  value?: boolean | false;
  onInput?: (value: boolean) => any;
  disabled?: boolean | false;

  constructor(args?: SwitchOptions) {
    this.id = args?.id || uuid.v4();
    this.label = args?.label;
    this.value = args?.value !== undefined ? args?.value : false;
    this.onInput = args?.onInput;
    this.disabled = args?.disabled !== undefined ? args?.disabled : false;
  }
}

@UntilDestroy()
@Component({
  selector: 'ncp-switch',
  imports: [],
  templateUrl: './switch.component.html',
  styleUrl: './switch.component.scss',
})
export class SwitchComponent implements OnInit {
  @ViewChild('switchEl') public switchEl!: ElementRef<HTMLInputElement>;
  private readonly translate = inject(TranslateService);
  protected translations = this.translate.instant('switch');

  options = model(new SwitchOptions());

  ngOnInit(): void {
    this.translate.onLangChange.pipe(untilDestroyed(this)).subscribe((event) => {
      this.translations = this.translate.instant('switch');
    });
  }

  onInput(input: HTMLInputElement) {
    if (this.options()?.onInput) {
      this.options().value = this.switchEl.nativeElement.checked;
      this.options().onInput?.(this.switchEl.nativeElement.checked);
      input.value = this.options().value!.toString();
    }
  }
}
